/**
 * EnableUserSelect
 */
import * as React from 'react';

// Styles
import './styles.scss';

interface Props {
    children?: React.Node;
}

export default class EnableUserSelect extends React.PureComponent<Props> {
    render() {
        const { children } = this.props;
        if (!children) return null;
        return <div className="enable-user-select">{children}</div>;
    }
}
